export function creationPrintJobPath(id) {
  return `/creations/${id}/print_jobs/new`
}

export function creationPrintJobUrl(id) {
  const { host, protocol } = window.location
  return `${protocol}//${host}${creationPrintJobPath(id)}`
}
